import {
  Response,
  CustomerOrderInquiryCondition,
} from '../models/stock-summary-master.model';

import { MockService } from '../../../core/services/mock.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@environment';
import { Observable, map, delay } from 'rxjs';
import { Injectable } from '@angular/core';
import { 
  CurrencyResponse,
  CustomerOrderInqHeaderResponse,
  CustomerOrderInqLineResponse
} from '../models/customer-order-inquiry.model';

@Injectable({
  providedIn: 'root',
})
export class CustomerOrderInquiryService {
  // 測試範例為了模擬資料查詢時間，實際開發不會用到
  delay: number = 500;

  constructor(
    private readonly mockService: MockService,
    private readonly httpClient: HttpClient
  ) {}

  getCustomerOrderInquiry(
    condition: CustomerOrderInquiryCondition
  ): Observable<Response> {
    let endpoint = `${environment.apiEndpoint}/customer-order-inquiry`;
    endpoint = this.mockService.parseApiEndpoint(
      endpoint,
      '/api/v1/item360/customer-order-inquiry.json'
    );

    if (environment.apiMock) {
      return this.httpClient.get<Response>(endpoint).pipe(
        map((data) => data),
        delay(this.delay)
      );
    }
    return this.httpClient.post<Response>(endpoint, condition);
  }

  /**
   * 取得客戶訂單查詢表頭資料
   * POST /api/v1/item360/customer-order-inq/header
   * 
   * @param condition 查詢條件
   * @returns 客戶訂單表頭響應資料
   */
  getCustomerOrderInqHeader(
    condition: CustomerOrderInquiryCondition
  ): Observable<CustomerOrderInqHeaderResponse> {
    let endpoint = `${environment.apiEndpoint}/customer-order-inq/header`;
    endpoint = this.mockService.parseApiEndpoint(
      endpoint,
      '/api/v1/item360/customer-order-inq-header.json'
    );

    if (environment.apiMock) {
      return this.httpClient.get<CustomerOrderInqHeaderResponse>(endpoint).pipe(
        map((data) => data),
        delay(this.delay)
      );
    }

    const body = {
      ouId: condition.ouId,
      inventoryItemId: condition.inventoryItemId,
      empNo: condition.empNo,
      type: condition.type,
      currency: condition.currency || '',
      language: condition.language || 'US'
    };

    return this.httpClient.post<CustomerOrderInqHeaderResponse>(endpoint, body);
  }

  /**
   * 取得客戶訂單查詢明細資料
   * POST /api/v1/item360/customer-order-inq/line
   * 
   * @param condition 查詢條件
   * @returns 客戶訂單明細響應資料
   */
  getCustomerOrderInqLine(
    condition: CustomerOrderInquiryCondition
  ): Observable<CustomerOrderInqLineResponse> {
    let endpoint = `${environment.apiEndpoint}/customer-order-inq/line`;
    endpoint = this.mockService.parseApiEndpoint(
      endpoint,
      '/api/v1/item360/customer-order-inq-line.json'
    );

    if (environment.apiMock) {
      return this.httpClient.get<CustomerOrderInqLineResponse>(endpoint).pipe(
        map((data) => data),
        delay(this.delay)
      );
    }

    const body = {
      ouId: condition.ouId,
      inventoryItemId: condition.inventoryItemId,
      orgId: (condition as any).orgId,
      empNo: condition.empNo,
      type: condition.type,
      currency: condition.currency || '',
      language: condition.language || 'US'
    };

    return this.httpClient.post<CustomerOrderInqLineResponse>(endpoint, body);
  }

  /**
   * 取得幣別清單
   * GET /proxy/common/api/v1/common/currency/currencies?currencyFlag=Y
   * 
   * @returns 幣別清單
   */
  getCurrencies(): Observable<CurrencyResponse[]> {
    const endpoint = `${environment.commonApiEndpoint}/currency/currencies`;
    const httpParams = new HttpParams({
      fromObject: {
        currencyFlag: 'Y'
      }
    });

    return this.httpClient.get<CurrencyResponse[]>(endpoint, { params: httpParams });
  }
}
